import React from "react";
import CustomButton from "../../UI/Buttons/CustomButton";
import RoundedPlus from "../../UI/Icons/RoundedPlus";
import { useAppSelector } from "../../../store";
import { useLocation, useNavigate } from "react-router";
import { AUTH_ROUTE } from "../../../pages/App/routes";

interface JobHeaderProps {
  urgentJobCount?: number;
  scheduledJobCount?: number;
  acceptedJobCount?: number;
}

const JobHeader: React.FC<JobHeaderProps> = ({
  urgentJobCount,
  scheduledJobCount,
  acceptedJobCount,
}) => {
  const {
    totalUrgentVacancies,
    totalScheduledVacancies,
    totalAcceptedVacancies,
  } = useAppSelector((state) => state.vacancy);
  const navigate = useNavigate();
  const location = useLocation();

  const handleUrgentVacancyNavigation = () => {
    navigate(AUTH_ROUTE.ADMIN_URGENT_VACANCIES);
  };

  const handleSchduledVacancyNavigation = () => {
    navigate(AUTH_ROUTE.ADMIN_SCHEDULED_VACANCIES);
  };

  const handleAcceptedVacancyNavigation = () => {
    navigate(AUTH_ROUTE.ADMIN_ACCEPTED_VACANCIES);
  };

  const handleVacancyHistory = () => {
    navigate(AUTH_ROUTE.ADMIN_HISTORY_VACANCIES);
  };

  const handleActiveTab = (tableName: string) => {
    if (location.pathname.includes(tableName)) {
      return "bg-black text-white";
    } else {
      return "bg-off-white text-black";
    }
  };

  const handleCreateVacancy = () => {
    navigate(AUTH_ROUTE.ADMIN_CREATE_VACANCY);
  };

  return (
    <>
      <div className="d-flex flex-column gap-10">
        <div className="d-flex flex-column">
          <div className="d-flex gap-20 justify-content-between overflow-auto mobile-scroll-hide">
            <div className="d-flex gap-10">
              <div
                className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px py-5px cursor-pointer ${handleActiveTab(
                  "urgent"
                )}`}
                onClick={handleUrgentVacancyNavigation}
              >
                <span className="fw-700">{totalUrgentVacancies}</span> Urgent
              </div>
              <div
                className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px py-5px cursor-pointer ${handleActiveTab(
                  "scheduled"
                )}`}
                onClick={handleSchduledVacancyNavigation}
              >
                <span className="fw-700">{totalScheduledVacancies}</span>{" "}
                Scheduled
              </div>
              <div
                className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px py-5px cursor-pointer ${handleActiveTab(
                  "accepted"
                )}`}
                onClick={handleAcceptedVacancyNavigation}
              >
                <span className="fw-700">{totalAcceptedVacancies}</span>{" "}
                Accepted
              </div>
              <div
                className={`d-flex gap-5 align-items-center top-radius-10px fs-22 fs-mobile-16 fw-400 px-15px py-5px cursor-pointer ${handleActiveTab(
                  "history"
                )}`}
                onClick={handleVacancyHistory}
              >
                History
              </div>
            </div>
            <div className="d-none d-lg-block pb-5px">
              <CustomButton
                variant={"primary"}
                type="button"
                className="btn-theme bg-teal text-black text-nowrap"
                onClick={handleCreateVacancy}
              >
                <RoundedPlus
                  className="min-w-20px"
                  width={20}
                  height={20}
                  fill="black"
                />
                Create a Vacancy
              </CustomButton>
            </div>
          </div>
          <div className="bg-black w-100 h-5px"></div>
        </div>
        <div className="d-block d-lg-none text-center">
          <CustomButton
            variant={"primary"}
            type="button"
            className="btn-theme bg-teal text-black text-nowrap"
            onClick={handleCreateVacancy}
          >
            <RoundedPlus
              className="min-w-20px"
              width={20}
              height={20}
              fill="black"
            />
            Create a Vacancy
          </CustomButton>
        </div>
      </div>
    </>
  );
};

export default JobHeader;
